import styled, { keyframes } from 'styled-components';
import React from 'react';

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;
const SkeletonBase = styled.div`
  background: linear-gradient(
    90deg,
    rgba(224, 224, 224, 0.8) 25%,
    rgba(240, 240, 240, 0.9) 50%,
    rgba(224, 224, 224, 0.8) 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 2s infinite;
  border-radius: ${({ theme }) => theme.borderRadius};
`;
export const SkeletonContainer = styled.main`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  /* padding: ${({ theme }) => theme.spacing.m}; */
`;

export const SkeletonHeader = styled(SkeletonBase)`
  width: 98%;
  height: 50px;
  background-color: ${({ theme }) => theme.colors.grey3};
  margin-bottom: ${({ theme }) => theme.spacing.m};
  border-radius: ${({ theme }) => theme.borderRadius};
`;

export const SkeletonContent = styled(SkeletonBase)`
  display: flex;
  width: 100%;
  height: 100%;
  gap: ${({ theme }) => theme.spacing.m};

  @media screen and (max-width: 1300px) {
    flex-direction: column;
  }
`;

export const SkeletonLeft = styled.div`
  width: 75%;
  height: 100vh;
  padding-top: ${({ theme }) => theme.spacing.m};
  padding: ${({ theme }) => theme.spacing.m} ${({ theme }) => theme.spacing.xl};
  @media screen and (max-width: 1300px) {
    width: 100%;
  }
`;

export const SkeletonRight = styled.div`
  width: 25%;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.grey4};
  padding-top: ${({ theme }) => theme.spacing.l};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.m};
  @media screen and (max-width: 1300px) {
    display: none;
  }
`;

export const SkeletonRightLight = styled.div`
  width: 25%;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.grey1};
  padding-top: ${({ theme }) => theme.spacing.l};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.m};
  @media screen and (max-width: 1300px) {
    display: none;
  }
`;

export const SkeletonButton = styled(SkeletonBase)`
  width: 90%;
  height: 40px;
  background-color: ${({ theme }) => theme.colors.grey3};
  border-radius: ${({ theme }) => theme.borderRadius};
  margin-top: ${({ theme }) => theme.spacing.m};
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const SkeletonBreadcrumbs = styled(SkeletonBase)`
  width: 80%;
  height: 20px;
  background-color: ${({ theme }) => theme.colors.grey3};
  margin-block: ${({ theme }) => theme.spacing.s};
  border-radius: ${({ theme }) => theme.borderRadius};
  @media screen and (max-width: 1300px) {
    display: none;
  }
`;
export const SkeletonPresentation = styled(SkeletonBase)`
  width: 98%;
  height: 50%;
  background-color: ${({ theme }) => theme.colors.grey3};
  margin-bottom: ${({ theme }) => theme.spacing.m};
  border-radius: ${({ theme }) => theme.borderRadius};
`;

export const SkeletonSmallSection = styled(SkeletonBase)`
  width: 98%;
  height: 20%;
  background-color: ${({ theme }) => theme.colors.grey3};
  margin-bottom: ${({ theme }) => theme.spacing.m};
  border-radius: ${({ theme }) => theme.borderRadius};
`;

const CourseLoadingPage = () => {
  return (
    <SkeletonContainer>
      <SkeletonContent>
        <SkeletonRight>
          <SkeletonBreadcrumbs />
          <SkeletonBreadcrumbs />
          <SkeletonBreadcrumbs />
          <SkeletonBreadcrumbs />
          <SkeletonButton />
        </SkeletonRight>
        <SkeletonLeft>
          <SkeletonHeader />
          <SkeletonPresentation />
          <SkeletonSmallSection />
          <SkeletonSmallSection />
        </SkeletonLeft>
      </SkeletonContent>
    </SkeletonContainer>
  );
};

export default CourseLoadingPage;
